import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  AsyncStatusState,
  AsyncSuccessPayload,
  StartAsyncTaskPayload
} from './types'

const initialState: AsyncStatusState = {
  initiator: null,
  config: {},
}

const asyncStatusSlice = createSlice({
  name: 'asyncStatus',
  initialState,
  reducers: {
    startAsyncTask: (state, { payload }: PayloadAction<StartAsyncTaskPayload>) => {
      // Configures data for the async request
      const { endpoint, body, method } = payload
      state[endpoint] = null // Clear current results
      state.initiator = endpoint // Set the trigger
      // Store the request config
      state.config[endpoint] = {
        body,
        method,
      }
    },
    clearInitiator: (state) => {
      // Indicate that the trigger has been processed
      state.initiator = null
    },
    asyncSuccess: (state, { payload }: PayloadAction<AsyncSuccessPayload>) => {
      state[payload.endpoint] = payload.result
    },
  },
})

// Action creators are generated for each case reducer function
export const { startAsyncTask, clearInitiator, asyncSuccess } = asyncStatusSlice.actions

export default asyncStatusSlice.reducer
